import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CustomError } from '@api/interceptors/models';
import { LogsService } from '@shared/services/logs';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  private readonly logs = inject(LogsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((e) => {
        if (e instanceof HttpErrorResponse) {
          if (e.status === 0) {
            this.logs.warn('ResponseInterceptor', 'Network error (status 0)', { url: req.urlWithParams }, e);
          }
        }
        const { status, error } = e as CustomError;
        return throwError(() => ({
          server: e as HttpErrorResponse,
          error,
          status,
        }));
      })
    );
  }
}
